import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { getDatabase, ref, child, get } from "firebase/database";
import { auth } from "./Firebase";
import { getAuth } from "firebase/auth";
import Backend from './Backend';

export default function DisplayUserData() {
  const [users, setUsers] = useState([]);
  
  useEffect(() => {
    const auth1 = getAuth();
    const user = auth1.currentUser;
    const navigate = useNavigate;
    // console.log(user);
    const dbRef = ref(getDatabase());
    get(child(dbRef, `users/${user.uid}`)).then((snapshot) => {
      if (snapshot.exists()) {
        setUsers(snapshot.val());
        // console.log(users.Name);
      } else {
        console.log("No data available");
      navigate('/userInfo')
      }
    }).catch((error) => {
      console.error(error);
    });
  }, []);

  return (
    <div className='my-5' style={{color: "white", textAlign: "center"}}>
        <hr className='my-5' style={{backgroundColor: "black", visibility: "hidden"}}></hr>
        <h3>
      Name: {users.Name}<br></br>
      Address Of User: {users.address}<br></br>
      Phone: {users.phone}<br></br>
        </h3>
        <Backend />
    </div>
  )
}
